import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import {
  jamboCareLogo,
  searchIcon,
  rightDirectionIcon,
  leftDirectionIcon,
} from "../../../assets";
import SearchSelectDropdown from "../../Atoms/SearchSelectDropdown/EventEHRSearchSelectDropdown";
import CloseIcon from "@mui/icons-material/Close";
import FacilityDropdown from "../../Molecules/FacilityDropdown/FacilityDropdown";
import { shouldShowSwitchToProvider } from "../../../utils/getToken";
interface EventEHRSmallScreenMenuDrawerProps {
  open: boolean;
  searchFieldData?: any;
  handleMenuItem?: (event: any) => void;
  handleCloseDrawer?: () => void;
  handleSearchChangeValue?: (event: any) => void;
  handleSelectedSearchValue?: (event: any) => void;
}

export default function EventEHRSmallScreenMenuDrawer({
  open,
  searchFieldData,
  handleMenuItem,
  handleCloseDrawer,
  handleSearchChangeValue,
  handleSelectedSearchValue,
}: EventEHRSmallScreenMenuDrawerProps) {
  const path = window.location.pathname.split("/")[1];
  const [selectedPage, setSelectedPage] = React.useState<string>(
    path ? path?.charAt(0)?.toUpperCase() + path?.slice(1) : "Dashboard",
  ); // Track selected page

  const toggleDrawer = (e: any) => () => {
    e.stopPropagation();
    e.preventDefault();
    handleCloseDrawer && handleCloseDrawer();
  };

  React.useEffect(() => {
    setSelectedPage(
      path ? path?.charAt(0)?.toUpperCase() + path?.slice(1) : "Dashboard",
    );
  }, [path]);

  const DrawerList = (
    <Box
      sx={{ width: 300 }}
      role="presentation"
      onClick={(e) => toggleDrawer(e)}
    >
      <div className="mt-6 ml-4 mr-4 flex flex-col justify-start">
        <CloseIcon
          className="self-end cursor-pointer"
          onClick={() => handleCloseDrawer && handleCloseDrawer()}
        />
        <img
          src={jamboCareLogo}
          className="mb-6"
          alt="logo"
          style={{ height: "40px" }}
        />

        <div className="mb-3">
          <SearchSelectDropdown
            freeSolo={true}
            size="small"
            label="Search"
            fullWidth="100%"
            startIcon={
              <img
                alt="search-icon"
                src={searchIcon}
                width={"16px"}
                height={"16ppx"}
              />
            }
            options={searchFieldData}
            onSearchValueChangeCb={handleSearchChangeValue}
            onSelectSearchValue={(selectedValue) => {
              handleSelectedSearchValue &&
                handleSelectedSearchValue(selectedValue);
            }}
          />
        </div>

        {/* Switch to Provider Dropdown for Mobile */}
        {shouldShowSwitchToProvider() && (
          <div className="mb-4">
            <FacilityDropdown
              variant="mobile"
              onFacilitySelect={(facility) => {
                console.log("Selected facility from mobile:", facility);
                // TODO: Implement facility switching logic
                handleCloseDrawer && handleCloseDrawer();
              }}
            />
          </div>
        )}
      </div>
      <List>
        {[
          "Dashboard",
          "Facility-management",
          "Inventory-management",
          "Orders",
          "Documents",
          "Contact-directory",
          "Tasks",
          "Reports",
          "Settings",
        ].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton
              onClick={() => handleMenuItem && handleMenuItem(text)}
              sx={{
                background: text === selectedPage ? "#005596" : "",
                color: text === selectedPage ? "white" : "", // Set color dynamically
                "&:hover": {
                  background: text === selectedPage ? "#003d70" : "#f0f0f0", // Hover background
                  color: text === selectedPage ? "white" : "black", // Hover text color
                },
              }}
            >
              <ListItemText
                primary={
                  text === "Facility-management"
                    ? "Facility Management"
                    : text === "Contact-directory"
                      ? "Contact Directory"
                      : text === "Inventory-management"
                        ? "Inventory Management"
                        : text === "Orders"
                          ? "Supply/Order Management"
                          : text
                }
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      <Drawer open={open} onClose={(e) => toggleDrawer(e)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
